<template>
    <div class="main">
      <h1>Admin Survey Dashboard</h1>
      <div class="reports ">
            <div class="dropDowns report1" v-if="cadences.length > 0">
                <!-- <label for="">Survey </label> -->
                <div>
                    <div class="dropDown">
                        Forms:
                        <select name="" id="" v-model="selectedFormIndex" @change="changeForm">
                            <option v-for="form, index in allForms" :key="form.id" :value="index">{{form.label}} ({{form.cadence}})</option>
                        </select>
                    </div>
                    <div class="dropDown">
                        Stores:
                        <select name="" id="" v-model="selectedStoreNum" @change="getStoresWithSubmissions">
                            <option v-for="store in stores" :key="store.id" :value="store.store_num">{{store.store_num}} {{store.name}} </option>
                        </select>
                         <!-- <button>Download</button> -->
                    </div>
                    
                    <div class="dropDown cadence" v-if="allForms[selectedFormIndex].cadence == 'weekly'">
                        Week:
                        <select name="" id="" v-model="surveyCadenceIndex" @change="getStoresWithSubmissions">
                            <option :value="index" :key="cadence.id" v-for="cadence, index in cadences">{{cadence.label}}</option>
                        </select>
                        <!-- <button @click="downloadReportByForm">Download</button> -->
                    </div>
                    <div class="dropDown cadence" v-else>
                        Date Range:
                        <!-- <select name="" id="" v-model="surveyCadenceIndex" @change="getStoresWithSubmissions">
                            <option :value="index" :key="cadence.id" v-for="cadence, index in cadences">{{cadence.label}}</option>
                        </select> -->
                        <datepicker v-model="reportStartDate" @change="getStoresWithSubmissions" name="uniquename"></datepicker>
                        <datepicker v-model="reportEndDate" @change="getStoresWithSubmissions" name="uniquename"></datepicker>
                        
                    </div>
                    <div class="dropDown"><button @click="downloadReportByForm">Download</button></div>
                    <div class="summary">
                        <table>
                            <thead>
                                <tr>
                                    <th>Store</th>
                                    <th>Number</th>
                                    <th>Surveys Submitted</th>
                                    <th v-if="allForms[this.selectedFormIndex].cadence != 'one-time'">Missing Surveys</th>
                                    <th v-if="allForms[this.selectedFormIndex].cadence != 'one-time'">Zero Hours</th>
                                    <th><span v-if="cadences[surveyCadenceIndex].lock_date != null"><i class="fa-solid fa-lock"  @click="lockUnlockCadence(0)"></i>&nbsp;Click To Unlock</span><span v-else><i  @click="lockUnlockCadence(1)" class="fa-solid fa-unlock"></i>&nbsp;Click To Lock</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(store,storeIndex) in summary" :key="store.store_num">
                                    <td>{{store.name}}</td>
                                    <td>{{store.store_num}}</td>
                                    <td>{{store.count}}</td>
                                    <td v-if="allForms[this.selectedFormIndex].cadence != 'one-time'">{{ store.employee_count - store.count }}</td>
                                    <td v-if="allForms[this.selectedFormIndex].cadence != 'one-time'"><input type="checkbox" :checked="store.note_state == 1" @click="updateCadenceNote(store.note_state,store.store_num,storeIndex)"></td>
                                    <td>
                                        <i v-if="allForms[this.selectedFormIndex].cadence != 'one-time' && store.lock_state == 1" class="fa-solid fa-lock" @click="lockUnlockCadenceStore(0,store.store_num,storeIndex)"></i>
                                        <span v-else-if="allForms[this.selectedFormIndex].cadence != 'one-time' && store.lock_state == 0"><i class="fa-solid fa-unlock" @click="lockUnlockCadenceStore(1,store.store_num,storeIndex)"></i> Click to lock store</span>
                                        <span v-else>N/A</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- <button @click="downloadReportByForm">Download</button> -->
                </div>

            </div>
            <!-- <div class="dropDowns report2">
                <label for="">Survey</label>
                <div>
                    <div class="dropDown">
                        Stores:
                        <select name="" id="" v-model="selectedStoreNum">
                            <option v-for="store in stores" :key="store.id" :value="store.store_num">{{store.store_num}} {{store.name}} </option>
                        </select>
                         <button>Download</button>
                    </div>
                </div>
            </div> -->
      </div>
    </div>
  </template>
  
<script>
    import Cookies from 'js-cookie'
    import Datepicker from 'vuejs3-datepicker'
    export default {
        name: 'MainView',
        props: {
        msg: String
        },
        data() {
            return {
                token: null,
                cadences: [],
                user: null,
                // formID: this.$route.params.id,
                surveyCadenceIndex: -1,
                allForms:[],
                stores: [],
                selectedStoreNum: null,
                selectedFormIndex: -1,
                summary: null,
                reportStartDate: null,
                reportEndDate: null
            }
        },
        components: {
            Datepicker
        },
        methods: {
        getSiteCookie(name) {
            const value = Cookies.get(name);
            return value
        },
        changeForm(){
            this.cadences = this.allForms[this.selectedFormIndex].cadences;
            if(this.cadences.length > 0){
                this.surveyCadenceIndex = this.cadences.length -1
            }
            this.getStoresWithSubmissions();
        },
        async lockUnlockCadence(lock){
            // /admin/form/<form_id>/cadence/<cadence_id>/lock
            let data = {lock}, that = this
            let url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/cadence/'+this.cadences[this.surveyCadenceIndex].id+'/lock'
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url,
                data,
                headers: { 
                    'Authorization': `Bearer ${this.token}`,
                    'Content-Type': 'application/json'
                }
            };
            let response = await this.axios.request(config)
            if(response.data.success) {
                console.log(response.data)
                if(lock) {
                    this.$emit('displayGlobalMessage', {message:'The form is locked for the week', on: true, animate: false})
                    setTimeout(function(){that.$emit('displayGlobalMessage', {message:'', on: false,  duration: 0})}, 1000)
                }
                else {
                    this.$emit('displayGlobalMessage', {message:'The form is unlocked for the week', on: true, animate: false})
                    setTimeout(function(){that.$emit('displayGlobalMessage', {message:'', on: false,  duration: 0})}, 1000)
                } 
                    // this.$emit('displayGlobalMessage', {message:'The form is unlocked for the week', on: true,  duration: 1000})
                this.cadences[this.surveyCadenceIndex].lock_date = lock ? new Date() : null
                this.getStoresWithSubmissions();
            }
        },
        async lockUnlockCadenceStore(lock,store_number,index){
            // /admin/form/<form_id>/cadence/<cadence_id>/store/<store_number>/lock
            let data = {lock}, that = this
            let url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/cadence/'+this.cadences[this.surveyCadenceIndex].id+'/store/'+store_number+'/lock'
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url,
                data,
                headers: { 
                    'Authorization': `Bearer ${this.token}`,
                    'Content-Type': 'application/json'
                }
            };
            let response = await this.axios.request(config)
            if(response.data.success) {
                console.log(response.data)
                if(lock) {
                    this.summary[index].lock_state = 1;
                    this.$emit('displayGlobalMessage', {message:`The form is locked for store ${store_number}`, on: true, animate: false})
                    setTimeout(function(){that.$emit('displayGlobalMessage', {message:'', on: false,  duration: 0})}, 1000)
                }
                else {
                    this.summary[index].lock_state = 0;
                    this.$emit('displayGlobalMessage', {message:`The form is unlocked for store ${store_number}`, on: true, animate: false})
                    setTimeout(function(){that.$emit('displayGlobalMessage', {message:'', on: false,  duration: 0})}, 1000)
                } 
                    // this.$emit('displayGlobalMessage', {message:'The form is unlocked for the week', on: true,  duration: 1000})
                
            }
        },
        async updateCadenceNote(note,store_number,index){
            // /admin/form/<form_id>/cadence/<cadence_id>/store/<store_number>/note
            let data = {note}, that = this
            let url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/cadence/'+this.cadences[this.surveyCadenceIndex].id+'/store/'+store_number+'/note'
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url,
                data,
                headers: { 
                    'Authorization': `Bearer ${this.token}`,
                    'Content-Type': 'application/json'
                }
            };
            let response = await this.axios.request(config)
            if(response.data.success) {
                console.log(response.data)
                if(note != '1') {
                    this.summary[index].note_state = 1;
                    this.$emit('displayGlobalMessage', {message:`Zero hours updated for store ${store_number}`, on: true, animate: false})
                    setTimeout(function(){that.$emit('displayGlobalMessage', {message:'', on: false,  duration: 0})}, 1000)
                }
                else {
                    this.summary[index].note_state = 0;
                    this.$emit('displayGlobalMessage', {message:`Zero hours updated for store ${store_number}`, on: true, animate: false})
                    setTimeout(function(){that.$emit('displayGlobalMessage', {message:'', on: false,  duration: 0})}, 1000)
                } 
                    // this.$emit('displayGlobalMessage', {message:'The form is unlocked for the week', on: true,  duration: 1000})
                
            }
        },
        async downloadReportByForm(){
            // let that = this
            let url, data = {}
            if(this.allForms[this.selectedFormIndex].cadence != 'one-time') {
                url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/cadence/'+this.cadences[this.surveyCadenceIndex].id+'/download'
            }
            else {
                url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/download'
            }

            if(this.selectedStoreNum != null) 
                data.store_number = this.selectedStoreNum
            if(this.reportStartDate != null )
                data.start_date = this.reportStartDate
            if(this.reportEndDate != null )
                data.end_date = this.reportEndDate


            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url,
                data,
                headers: { 
                    'Authorization': `Bearer ${this.token}`,
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            };
            let response = await this.axios.request(config)
            if(response.data.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                // this.$emit('displayGlobalMessage', {message:'Error generating report', on: true,  duration: 5000})
                alert('No records found for the selected criteria')
                return
            }
            url = window.URL.createObjectURL(response.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'survey_data.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        },
        async getAllForms(){
            let that = this
            let url = process.env.VUE_APP_API_BASE_URL+'/admin/forms/cadences'
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url,
                headers: { 
                    'Authorization': `Bearer ${this.token}`,
                    'Content-Type': 'application/json'
                }
            };
            let response = await this.axios.request(config)
            if(response.data.success) {
                console.log(response.data)
                that.allForms = response.data.data
                that.selectedFormIndex = 0
                that.cadences = that.allForms[this.selectedFormIndex].cadences;
                if(that.cadences.length > 0){
                    that.surveyCadenceIndex = that.cadences.length -1
                }
            }
            //   setTimeout(()=>this.$emit('displayGlobalMessage', {message:'', on: false, animate: false}), 2000)
        },
        async getCadences(){
            let that = this
            let url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/cadences'
            let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url,
            headers: { 
                'Authorization': `Bearer ${this.token}`,
                'Content-Type': 'application/json'
            }
            };
            let response = await this.axios.request(config)
            if(response.data.success) {
            // console.log(response.data)
                that.cadences = response.data.data
                that.surveyCadenceIndex = this.cadences.length -1
            }
            //   setTimeout(()=>this.$emit('displayGlobalMessage', {message:'', on: false, animate: false}), 2000)
        },
        async getAllStores(){
            let that = this
            let url = process.env.VUE_APP_API_BASE_URL+'/admin/stores'
            let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url,
            headers: { 
                'Authorization': `Bearer ${this.token}`,
                'Content-Type': 'application/json'
            }
            };
            let response = await this.axios.request(config)
            if(response.data.success) {
                console.log(response.data)
                that.stores = response.data.data
                that.selectedStoreNum = ""
                that.stores.unshift({
                    account_number: "",
                    name: "All Stores",
                    store_num: "",

                })
            }
            //   setTimeout(()=>this.$emit('displayGlobalMessage', {message:'', on: false, animate: false}), 2000)
        },
        getStoresWithSubmissions(){
            this.$emit('displayGlobalMessage', {message:'Pulling report', on: true,  duration: 10000})
            let that = this, url, data = {}
            if(this.allForms[this.selectedFormIndex].cadence == "weekly")
                url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/cadence/'+this.cadences[this.surveyCadenceIndex].id+'/summary'
            else
                url = process.env.VUE_APP_API_BASE_URL+'/admin/form/'+this.allForms[this.selectedFormIndex].id+'/summary'
            if(this.selectedStoreNum != null) 
                data.store_number = this.selectedStoreNum
            if(this.reportStartDate != null )
                data.start_date = this.reportStartDate
            if(this.reportEndDate != null )
                data.end_date = this.reportEndDate    


            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url,
                data,
                headers: { 
                    'Authorization': `Bearer ${this.token}`,
                    'Content-Type': 'application/json'
                }
            };
            this.axios.request(config).then((response) => { 
                if(response.data.success) {
                    console.log(response.data)
                    that.summary = response.data.data
                }
                that.$emit('displayGlobalMessage', {message:'Pulling report', on: false,  duration: 1})
            })

        }
        //   formateDate(timestamp) {
        //     let dateObj = new Date(timestamp)
        //     return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`
        //   },
        },
        async mounted() {
            console.log('mounted')
            console.log(process.env, 'envionment varsxxx')
            let token = this.getSiteCookie('btoken')
            this.user = localStorage.getItem(token)
            this.token = token
            // if(process.env == 'development') {
            //     this.user.admin = true
            // }
            await this.getAllForms()
            //await this.getCadences()
            this.getStoresWithSubmissions()
            
            await this.getAllStores()

        },
        watch: {
            reportStartDate() {
                this.getStoresWithSubmissions()
            },
            reportEndDate(){
                this.getStoresWithSubmissions()
            }
        }
    }
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only --> 
  <style scoped lang="scss">



  .main{
    display:block;
    position:relative;
    text-align: left;;
    /* max-width:1200px; */
    h1{
    }
    .reports{
        position: relative;
        i.fa-solid{
            cursor: pointer;
            font-size:20px;
            /**opacity:0.5; **/
            color: #797979;
        }
        i.fa-solid:hover{
            /**opacity:1; **/
            color: black;
        }

        .dropDowns{
            select{
                height: 27px;
                display: inline-block;
                vertical-align: middle;
                padding:0 5px;
            }
            button {
                height: 27px;
                display: inline-block;
                vertical-align: middle;
                float:right;
            }
            position: relative;
            padding:10px;
            color:black;
            .dropDown{
                background-color: rgba(0,0,0, 0.05);
                display:inline-block;
                vertical-align: middle;
                box-sizing: border-box;
                margin:0 0 10px 0;
                padding:10px;
                border:1px solid #ebebeb;;
                border-radius: 3px;
                width:auto;
                button{
                    /* margin-left:20px; */
                }
                margin-right:10px;
            }
            .dropDown.cadence{
                display:inline-block;
                width:auto;
            }
            .summary {
                display:block;
                border:1px solid #ebebeb;
                border-radius: 5px;
                height:400px;
                overflow-y:scroll;
                margin-bottom:20px;
                table {
                    border-collapse: collapse;
                    width:100%;
                    th{
                        position:sticky;
                        top:0;
                        padding:10px;

                        background-color:rgb(243, 242, 242);
                    }
                    td{
                        border-bottom:1px solid #ebebeb;
                        padding:10px;
                    }
                }
            }
        }
    }
}
.vuejs3-datepicker__value {
    padding:4px 15px !important;
}
  </style>
  